import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const apiBaseURL = process.env.VUE_APP_API_URL;

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: [
        "isLoggedIn",
        "user",
        "layout",
        "lastLookedAtPhotoID",
        "wasInitiallyCharged",
        "recentlyViewed",
        "plan",
        "hasPaymentOption",
        "sessionToken",
        "buildHash",
        "feedType",
      ],
    }),
  ],
  state: {
    isLoggedIn: false,
    enableAnalytics: true,
    token: localStorage.getItem("user-token") || "",
    wasInitiallyCharged: false,
    hasPaymentOption: false,
    sessionToken: "",
    loginError: "",
    createAccountError: "",
    purchaseError: "",
    plan: "",
    user: {
      id: "",
      email: "",
      fname: "",
      lname: "",
      exclusiveCreditCount: 0,
      nonexclusiveCreditCount: 0,
      card: {
        brand: "",
        last_four: "",
        exp_year: "",
        exp_month: "",
      },
      invoices: [],
      claimedImages: [],
      claimedAnimations: [],
      expiredLicenses: [],
      collections: [],
      team: "",
      proFilesAllowed: "",
      following: [],
    },
    allArtists: [],
    topSellers: [],
    allFeaturedArtists: [],
    featuredArtists: [],
    verifiedArtists: [],
    availableArtwork: [],
    lastLookedAtPhotoID: "",
    lastLookedAtPhotoUrl: "",
    layout: "page-layout",
    recentlyViewed: [],
    couponSku: "",
    showClaimModal: false,
    showAddToCollectionModal: false,
    showCreateCollectionModal: false,
    showPreviewsModal: false,
    previewImage: "",
    previewType: "spotify",
    addToCollectionPhotoId: null,
    addToCollectionPhotoUrl: null,
    addToCollectionType: null,
    showEditCollectionModal: false,
    editCollectionId: null,
    editCollectionName: null,
    editCollectionPublic: null,
    categories: [
      { id: "1", category_name: "Abstract" },
      { id: "2", category_name: "3D" },
      { id: "3", category_name: "Collage" },
      { id: "4", category_name: "Photography" },
      { id: "5", category_name: "Illustration" },
      { id: "6", category_name: "Photo Manipulation" },
      { id: "7", category_name: "AI Generated" },
    ],
    searchPage: 1,
    randomFeaturedArtists: [],
    referral: "",
    buildHash: "",
    showLoginModal: false,
    feedType: "featured",
    feedLoaded: false,
    feedArtwork: [],
    feedEnd: 100,
    feedPage: 1,
    top12: [],
    limitTotal: "1000",
    top6animations: [],
    top8pro: [],
    totalCount: {
      photos: null,
      animations: null,
      artists: null,
    },
    // notifications: [],
    stripe: {
      cartItems: [],
      cartTotal: 0,
      cartFees: 0,
      cartUnavailable: [],
    },
    showCart: false,
    showDesignServiceModal: false,
    lastAddedToCart: null,
  },
  actions: {
    getCart({ commit }) {
      axios.get(`${apiBaseURL}/api/artv1.1/user/getcart`).then((result) => {
        if (result.data.data.cart) {
          commit("setCart", result.data.data.cart);
          commit("setCartTotal", result.data.data.cart_total);
          commit("setCartFees", result.data.data.cart_fees);
          commit("setCartUnavailable", result.data.data.unavailable);
        }
      });
    },
    getTotalCount({ commit }) {
      axios.get(`${apiBaseURL}/api/artv1.1/photo/totals`).then((result) => {
        const formatNumber = (num) => {
          return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        };

        if (
          result.data.data.photos &&
          result.data.data.animations &&
          result.data.data.artists
        ) {
          const totals = {
            photos: formatNumber(parseInt(result.data.data.photos)),
            animations: formatNumber(parseInt(result.data.data.animations)),
            artists: formatNumber(parseInt(result.data.data.artists)),
          };
          // console.log("DEBUG: totals: ", totals);
          commit("setTotalCount", totals);
        }
      });
    },
    // getNotifications({ commit }) {
    //   axios
    //     .get(`${apiBaseURL}/api/artv1.1/user/notifications`)
    //     .then((result) => {
    //       if (result.data.data.notifications) {
    //         const notifications = result.data.data.notifications;
    //         for (var i = 0; i < notifications.length; i++) {
    //           if (
    //             notifications[i].artwork_url &&
    //             notifications[i].artwork_url.includes("animation")
    //           ) {
    //             notifications[
    //               i
    //             ].thumbnail = `${process.env.VUE_APP_ANIMATION_CDN_URL}${notifications[i].thumbnail}`;
    //           } else {
    //             notifications[
    //               i
    //             ].thumbnail = `${process.env.VUE_APP_CDN_BASE_URL}${notifications[i].thumbnail}`;
    //           }
    //         }
    //         commit("setNotifications", notifications);
    //       }
    //     });
    // },
    getAllArtists({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/artist/searchinfo`)
        .then((result) => result.data.data.artists)
        .then((artists) => {
          commit("setAllArtists", artists);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getTop12({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/photo/top12`)
        .then((result) => result.data.data.photos)
        .then((photos) => {
          for (var i = 0; i < photos.length; i++) {
            photos[
              i
            ].artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${photos[i].artist_profile_image}`;
            photos[
              i
            ].url_path = `${process.env.VUE_APP_CDN_BASE_URL}${photos[i].url_path}`;
          }
          // console.log("DEBUG: TOP12: ", photos);
          commit("setTop12", photos);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getTop8pro({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/photo/top8pro`)
        .then((result) => result.data.data.photos)
        .then((photos) => {
          for (var i = 0; i < photos.length; i++) {
            photos[
              i
            ].artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${photos[i].artist_profile_image}`;
            photos[
              i
            ].url_path = `${process.env.VUE_APP_CDN_BASE_URL}${photos[i].url_path}`;
          }
          // console.log("DEBUG: top8pro: ", photos);
          commit("setTop8pro", photos);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getTop6animations({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/photo/top6animations`)
        .then((result) => result.data.data.animations)
        .then((animations) => {
          for (let anim of animations) {
            anim.artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${anim.artist_profile_image}`;
            anim.url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${anim.url_path}`;
            anim.poster_url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${anim.poster_url_path}`;
          }
          // console.log("DEBUG: animations: ", animations);
          commit("setTop6animations", animations);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getFollowing({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/user/getfollowing`)
        .then((result) => result.data.data.following)
        .then((artists) => {
          commit("setFollowing", following);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    async getVerifiedArtists({ commit }) {
      await axios
        .get(`${apiBaseURL}/api/artv1.1/artist/verifiedartists`)
        .then((result) => {
          const artists = result.data.data.artists;

          for (var i = 0; i < artists.length; i++) {
            artists[
              i
            ].profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${artists[i].profile_image}`;
            if (artists[i].featured_image_url) {
              artists[
                i
              ].featured_image = `${process.env.VUE_APP_CDN_BASE_URL}${artists[i].featured_image_url}`;
            }
            if (artists[i].first_name || artists[i].last_name) {
              artists[
                i
              ].name = `${artists[i].first_name} ${artists[i].last_name}`;
            }
            if (artists[i].is_partner == 1) {
              artists[i].is_partner = true;
            } else {
              artists[i].is_partner = false;
            }
          }

          artists.sort(function (a, b) {
            return (
              a.top_seller_position ||
              a.top_seller_position - b.top_seller_position ||
              ("" + a.handle).localeCompare(b.handle)
            );
          });
          commit("setVerifiedArtists", artists);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    async getFeaturedArtists({ commit }) {
      await axios
        .get(`${apiBaseURL}/api/artv1.1/artist/featuredartists`)
        .then((result) => {
          const topSellers = [];
          const featuredArtists = [];
          const artists = result.data.data.artists;

          for (var i = 0; i < artists.length; i++) {
            artists[
              i
            ].profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${artists[i].profile_image}`;
            if (artists[i].featured_image_url) {
              artists[
                i
              ].featured_image = `${process.env.VUE_APP_CDN_BASE_URL}${artists[i].featured_image_url}`;
            }
            if (artists[i].first_name || artists[i].last_name) {
              artists[
                i
              ].name = `${artists[i].first_name} ${artists[i].last_name}`;
            }
            if (artists[i].is_partner == 1) {
              artists[i].is_partner = true;
            } else {
              artists[i].is_partner = false;
            }
            if (artists[i].is_verified == 1) {
              artists[i].is_verified = true;
            } else {
              artists[i].is_verified = false;
            }
            if (artists[i].is_top_seller == 1) {
              topSellers.push(artists[i]);
            } else {
              featuredArtists.push(artists[i]);
            }
          }

          artists.sort(function (a, b) {
            return ("" + a.handle).localeCompare(b.handle);
          });
          commit("setAllFeaturedArtists", artists);

          topSellers.sort(function (a, b) {
            return (
              parseInt(a.top_seller_position) - parseInt(b.top_seller_position)
            );
          });
          commit("setTopSellers", topSellers);

          featuredArtists.sort(function (a, b) {
            return ("" + a.handle).localeCompare(b.handle);
          });
          commit("setFeaturedArtists", featuredArtists);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getAvailableArtwork(context, num) {
      axios
        .post(`${apiBaseURL}/api/artv1.1/photo/preview_with_artist_page`, {
          page: num,
        })
        .then((result) => {
          const artwork = result.data.data.photos;
          let artists = result.data.data.artists;

          for (let i = 0; i < artwork.length; i++) {
            artwork[
              i
            ].url_path = `${process.env.VUE_APP_CDN_BASE_URL}${artwork[i].url_path}`;
            for (let j = 0; j < artists.length; j++) {
              if (artwork[i].artist_id == artists[j].artist_id) {
                artwork[i].artist_handle = artists[j].handle;
                artwork[
                  i
                ].artist_profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${artists[j].profile_image}`;

                break;
              }
            }
          }
          context.commit("setAvailableArtwork", artwork);
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    async loginRequest({ commit }, credentials) {
      commit("loginError", "");

      await axios
        .post(`${apiBaseURL}/api/artv1.1/user/login`, {
          email: credentials.email,
          password: credentials.password,
        })
        .then((result) => {
          if (result.data.error_code == 0 && result.data.message == "Success") {
            if (result.data.data.bearer_token.length >= 64) {
              localStorage.setItem("user-token", result.data.data.bearer_token);
              axios.defaults.headers.common["Authorization"] =
                "bearer " + result.data.data.bearer_token;
              commit("token", result.data.data.bearer_token);
              commit("isLoggedIn", true);
              commit("wasInitiallyCharged", false);
              commit("user", {
                id: result.data.data.id,
                email: credentials.email,
                fname: result.data.data.first_name,
                lname: result.data.data.last_name,
                exclusiveCreditCount: result.data.data.exclusive_credit_count,
                nonexclusiveCreditCount:
                  result.data.data.nonexclusive_credit_count,
                team: result.data.data.team,
                proFilesAllowed:
                  result.data.data.pro_files_allowed > 0 ? true : false,
                following: result.data.data.following,
              });

              if (result.data.data.was_initially_charged == 1) {
                commit("wasInitiallyCharged", true);
              }
            } else {
              commit(
                "loginError",
                "Email or password is incorrect. Please try again."
              );
            }
          } else {
            commit(
              "loginError",
              "Email or password is incorrect. Please try again."
            );
          }
        })
        .catch((error) => {
          localStorage.removeItem("user-token");
        });
    },
    logoutRequest({ commit }) {
      commit("isLoggedIn", false);
      commit("token", "");
      commit("wasInitiallyCharged", false);
      commit("hasPaymentOption", false);
      commit("randomFeaturedArtists", []);
      commit("user", {
        email: "",
        fname: "",
        lname: "",
        exclusiveCreditCount: 0,
        nonexclusiveCreditCount: 0,
        card: {},
        invoices: [],
        claimedImages: [],
        claimedAnimations: [],
        collections: [],
        id: "",
        team: "",
        proFilesAllowed: "",
        following: [],
        feedLoaded: false,
        feedArtwork: [],
        feedType: "featured",
      });
      commit("setCart", []);
      commit("setCartTotal", 0);
      commit("setCartFees", 0);
      localStorage.removeItem("user-token");
      delete axios.defaults.headers.common["Authorization"];
    },
    getPaymentOption({ commit }) {
      // Get payment option info
      axios
        .get(`${apiBaseURL}/api/artv1.1/user/paymentoptioninfo`)
        .then((result) => {
          if (
            result.data.data.message &&
            result.data.data.message == "success"
          ) {
            commit("hasPaymentOption", true);
            commit("user", {
              card: {
                brand: result.data.data.card.brand,
                last_four: result.data.data.card.last_four,
                exp_year: result.data.data.card.exp_year,
                exp_month: result.data.data.card.exp_month,
              },
            });
          } else {
            commit("hasPaymentOption", false);
            commit("user", { card: {} });
          }
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          commit("hasPaymentOption", false);
          commit("user", { card: {} });
        });
    },
    getPaymentHistory({ commit }) {
      axios
        .request({
          url: `${apiBaseURL}/api/artv1.1/user/invoicehistory`,
          method: "get",
          data: {},
        })
        .then((result) => {
          if (
            result.data.data.message &&
            result.data.data.message !== "error"
          ) {
            let invoices = [];

            for (var i = 0; i < result.data.data.invoices.length; i++) {
              if (result.data.data.invoices[i].paid == true) {
                invoices.push({
                  id: i,
                  status: "Paid",
                  amount_paid: result.data.data.invoices[i].amount_paid,
                  created: result.data.data.invoices[i].created,
                  invoice_url: result.data.data.invoices[i].receipt_url,
                  card_brand: result.data.data.invoices[i].card_brand,
                  last_four: result.data.data.invoices[i].last_four,
                });
              }
            }
            commit("setPaymentHistory", invoices);
          }
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getCollections({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/user/getcollections`)
        .then((result) => {
          if (result.data.data.collections) {
            const collections = result.data.data.collections;

            if (collections.length > 0) {
              for (let i = 0; i < collections.length; i++) {
                if (collections[i].photos.length > 0) {
                  for (let j = 0; j < collections[i].photos.length; j++) {
                    collections[i].photos[
                      j
                    ].url_path = `${process.env.VUE_APP_CDN_BASE_URL}${collections[i].photos[j].url_path}`;
                    collections[i].photos[
                      j
                    ].profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${collections[i].photos[j].profile_image}`;
                  }
                }
                if (collections[i].animations.length > 0) {
                  for (let j = 0; j < collections[i].animations.length; j++) {
                    collections[i].animations[
                      j
                    ].url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${collections[i].animations[j].url_path}`;
                    collections[i].animations[
                      j
                    ].poster_url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${collections[i].animations[j].poster_url_path}`;
                    collections[i].animations[
                      j
                    ].profile_image = `${process.env.VUE_APP_CDN_BASE_URL}${collections[i].animations[j].profile_image}`;
                  }
                }
              }
            }
            commit("user", {
              id: result.data.data.user_id,
              collections: result.data.data.collections,
            });
          } else {
            commit("user", { collections: [] });
          }
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getClaimedImages({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/photo/claimed`)
        .then((result) => {
          let images = [];
          let animations = [];

          if (result.data.data.photos && result.data.data.photos.length > 0) {
            images = result.data.data.photos;
            for (let i = 0; i < images.length; i++) {
              images[
                i
              ].url_path = `${process.env.VUE_APP_CDN_BASE_URL}${images[i].url_path}`;
            }
            commit("setClaimedImages", images);
          }

          if (
            result.data.data.animations &&
            result.data.data.animations.length > 0
          ) {
            animations = result.data.data.animations;
            for (let i = 0; i < animations.length; i++) {
              animations[
                i
              ].url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${animations[i].url_path}`;
              animations[
                i
              ].poster_url_path = `${process.env.VUE_APP_ANIMATION_CDN_URL}${animations[i].poster_url_path}`;
            }
            commit("setClaimedAnimations", animations);
          }

          if (result.data.data.expired && result.data.data.expired.length) {
            commit("setExpiredLicenses", result.data.data.expired);
          }
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    getCreditInfo({ commit }) {
      axios
        .get(`${apiBaseURL}/api/artv1.1/user/creditinfo`)
        .then((result) => {
          if (
            result.data.data.message &&
            result.data.data.message === "Success"
          ) {
            commit("user", {
              exclusiveCreditCount: result.data.data.exclusive_credit_count,
            });
          }
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
        });
    },
    sendAnalytics({ commit, state }, pageInfo) {
      if (state.enableAnalytics) {
        let sendSessionToken = "";

        if (state.sessionToken.length >= 48) {
          sendSessionToken = state.sessionToken;
        }

        axios
          .request({
            baseURL: apiBaseURL,
            url: "/api/artv1.1/session/analytics",
            method: "post",
            data: {
              session_token: sendSessionToken,
              page: pageInfo.page,
              action: pageInfo.action,
              session_data: "",
              diff_time: 0.0,
            },
          })
          .then((result) => {
            if (
              result.data.error_code == 0 &&
              result.data.message == "Success"
            ) {
              if (
                typeof result.data.data.session_token === "undefined" &&
                result.data.data.session_token.length >= 48
              ) {
                /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
                console.error("Could Not Save Session Data");
              } else {
                commit("sessionToken", result.data.data.session_token);
              }
            } else {
              /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
              console.error("Could Not Save Session Data");
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    async createAccount({ commit }, credentials) {
      await axios
        .post(`${apiBaseURL}/api/artv1.1/user/create`, {
          email: credentials.email,
          password: credentials.password,
        })
        .then((result) => {
          if (result.data.error_code == 0 && result.data.message == "Success") {
            if (result.data.data.bearer_token.length >= 64) {
              localStorage.setItem("user-token", result.data.data.bearer_token);
              axios.defaults.headers.common["Authorization"] =
                "bearer " + result.data.data.bearer_token;
              commit("token", result.data.data.bearer_token);
              commit("isLoggedIn", true);
              commit("wasInitiallyCharged", false);
              commit("user", {
                email: credentials.email,
                fname: "",
                lname: "",
                id: result.data.data.user_id,
                exclusiveCreditCount: 0,
                nonexclusiveCreditCount: 0,
              });
            } else {
              commit(
                "createAccountError",
                "Email is already associated with an account. Please use a different email address."
              );
            }
          } else {
            commit(
              "createAccountError",
              "Server error. Please Try Again in 10 minutes."
            );
          }
        })
        .catch((error) => {
          /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
          console.error(error);
          commit(
            "createAccountError",
            "Server error. Please Try Again in 15 minutes."
          );
        });
    },
  },
  mutations: {
    showLoginModal(state, status) {
      state.showLoginModal = status;
    },
    setFollowing(state, following) {
      state.user.following = following;
    },
    setFeedArtwork(state, photos) {
      state.feedArtwork = photos;
    },
    setFeedType(state, type) {
      state.feedType = type;
    },
    setFeedLoaded(state, loaded) {
      state.feedLoaded = loaded;
    },
    setFeedEnd(state, end) {
      state.feedEnd = end;
    },
    setFeedPage(state, page) {
      state.feedPage = page;
    },
    setAllArtists(state, artists) {
      state.allArtists = artists;
    },
    setTotalCount(state, totals) {
      state.totalCount = totals;
    },
    setTop12(state, photos) {
      state.top12 = photos;
    },
    setTop8pro(state, photos) {
      state.top8pro = photos;
    },
    setTop6animations(state, animations) {
      state.top6animations = animations;
    },
    setTopSellers(state, topSellers) {
      state.topSellers = topSellers;
    },
    setFeaturedArtists(state, featuredArtists) {
      state.featuredArtists = featuredArtists;
    },
    setVerifiedArtists(state, verifiedArtists) {
      state.verifiedArtists = verifiedArtists;
    },
    setAllFeaturedArtists(state, allFeaturedArtists) {
      state.allFeaturedArtists = allFeaturedArtists;
    },
    setAvailableArtwork(state, availableArtwork) {
      state.availableArtwork = [...state.availableArtwork, ...availableArtwork];
    },
    setlastLookedAtPhotoID(state, lastLookedAtPhotoID) {
      state.lastLookedAtPhotoID = lastLookedAtPhotoID;
    },
    setlastLookedAtPhotoUrl(state, lastLookedAtPhotoUrl) {
      state.lastLookedAtPhotoUrl = lastLookedAtPhotoUrl;
    },
    setLayout(state, layout) {
      state.layout = layout;
    },
    isLoggedIn(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setPlan(state, plan) {
      state.plan = plan;
    },
    setLimitTotal(state, total) {
      state.limitTotal = total;
    },
    wasInitiallyCharged(state, wasInitiallyCharged) {
      state.wasInitiallyCharged = wasInitiallyCharged;
    },
    hasPaymentOption(state, hasPaymentOption) {
      state.hasPaymentOption = hasPaymentOption;
    },
    setPaymentHistory(state, invoices) {
      state.user.invoices = invoices;
    },
    setClaimedImages(state, images) {
      state.user.claimedImages = images;
    },
    setClaimedAnimations(state, animations) {
      state.user.claimedAnimations = animations;
    },
    setExpiredLicenses(state, expired) {
      state.user.expiredLicenses = expired;
    },
    showClaimModal(state, status) {
      state.showClaimModal = status;
    },
    setPreviewImage(state, image) {
      state.previewImage = image;
    },
    showPreviewsModal(state, status) {
      state.showPreviewsModal = status;
    },
    setPreviewType(state, type) {
      state.previewType = type;
    },
    showAddToCollectionModal(state, payload) {
      state.showAddToCollectionModal = payload.status;
      state.addToCollectionPhotoId = payload.photo_id;
      state.addToCollectionPhotoUrl = payload.sized_url;
      state.addToCollectionType = payload.type;
    },
    showEditCollectionModal(state, payload) {
      state.showEditCollectionModal = payload.status;
      state.editCollectionId = payload.id;
      state.editCollectionName = payload.name;
      state.editCollectionPublic = payload.is_public;
    },
    showCreateCollectionModal(state, status) {
      state.showCreateCollectionModal = status;
    },
    sessionToken(state, sessionToken) {
      state.sessionToken = sessionToken;
    },
    token(state, token) {
      state.token = token;
    },
    user(state, user) {
      // TODO: Figure out why this was being done...
      // if (user.exclusiveCreditCount > 0) {
      //   user.exclusiveCreditCount;
      // } else {
      //   user.exclusiveCreditCount = 0;
      // }

      // if (user.nonexclusiveCreditCount > 0) {
      //   user.nonexclusiveCreditCount;
      // } else {
      //   user.nonexclusiveCreditCount = 0;
      // }

      state.user = { ...state.user, ...user };
    },
    loginError(state, error) {
      state.loginError = error;
    },
    createAccountError(state, error) {
      state.createAccountError = error;
    },
    purchaseError(state, error) {
      state.purchaseError = error;
    },
    randomFeaturedArtists(state, artists) {
      state.randomFeaturedArtists = artists;
    },
    setRecentlyViewed(state, image) {
      const index = state.recentlyViewed.findIndex((e) => e.id === image.id);

      if (index === -1) {
        state.recentlyViewed.unshift(image);
      } else {
        state.recentlyViewed.splice(index, 1);
        state.recentlyViewed.unshift(image);
      }
    },
    showCart(state, value) {
      state.showCart = value;
    },
    setSearchPage(state, page) {
      state.searchPage = page;
    },
    setReferral(state, referral) {
      state.referral = referral;
    },
    setBuildHash(state, hash) {
      state.buildHash = hash;
    },
    // setNotifications(state, notifications) {
    //   state.notifications = notifications;
    // },
    setCart(state, cart) {
      state.stripe.cartItems = cart;
    },
    setCartTotal(state, cartTotal) {
      state.stripe.cartTotal = cartTotal;
    },
    setCartFees(state, cartFees) {
      state.stripe.cartFees = cartFees;
    },
    setCartUnavailable(state, unavailable) {
      state.stripe.cartUnavailable = unavailable;
    },
    showDesignServiceModal(state, value) {
      state.showDesignServiceModal = value;
    },
    setLastAddedToCart(state, data) {
      state.lastAddedToCart = data;
    },
  },
  getters: {
    layout(state) {
      return state.layout;
    },
    isAuthenticated(state) {
      return !!state.token;
    },
    sessionToken(state) {
      return state.sessionToken;
    },
    user(state) {
      return state.user;
    },
  },
});
